export enum VbanStatus {
    Free = 0,
    'In-Active' = 1,
    Allocated = 2,
}